export interface FinishingMethod {
  id: string;
  code: string;
  name: string;
  description: string;
  engName: string;
}

export interface FinishingPart {
  id: string;
  code: string;
  name: string;
  engName: string;
  methods: FinishingMethod[];
}

export interface ColorOption {
  name: string;
  hex: string;
  category: string;
  pantoneCode?: string;
  tier?: 'popular' | 'premium';
  subcategory?: 'metallic' | 'pearl' | 'soft-touch';
}

export const finishingParts: FinishingPart[] = [
  {
    id: 'part-cap',
    code: '01',
    name: '뚜껑',
    engName: 'Cap',
    methods: [
      { id: 'method-01', code: '01', name: '유광코팅 (Gloss Coating)', description: '광택 코팅 마감 처리로 표면에 광택을 부여합니다. 투명하고 반짝이는 마감이 특징입니다.', engName: 'Gloss Coating' },
      { id: 'method-02', code: '02', name: '무광코팅 (Matte Coating)', description: '무광 코팅 마감 처리로 표면을 부드럽고 차분하게 마감합니다. 지문이 잘 묻지 않는 실용적인 마감입니다.', engName: 'Matte Coating' },
      { id: 'method-03', code: '03', name: 'UV코팅 (UV Coating)', description: '자외선 경화 코팅으로 높은 광택과 뛰어난 내구성을 제공합니다. 스크래치에 강한 고급 마감입니다.', engName: 'UV Coating' },
      { id: 'method-08', code: '08', name: '도금증착 (Plating Coating)', description: '금속 이온을 표면에 증착하여 메탈릭한 외관을 구현합니다. 고급스러운 금속 질감이 특징입니다.', engName: 'Plating Coating' },
      { id: 'method-04', code: '04', name: '소프트터치코팅 (Soft Touch Coating)', description: '부드러운 촉감의 코팅 처리로 벨벳 같은 질감을 부여합니다. 프리미엄 감성 연출에 탁월합니다.', engName: 'Soft Touch Coating' },
      { id: 'method-09', code: '09', name: '펄코팅 (Pearl Coating)', description: '진주 광택의 펄 안료를 코팅하여 우아한 광택 효과를 연출합니다. 각도에 따라 변화하는 고급스러운 마감입니다.', engName: 'Pearl Coating' },
      { id: 'method-10', code: '10', name: '그라데이션코팅 (Gradient Coating)', description: '두 가지 이상의 색상을 자연스럽게 그라데이션으로 코팅하여 감각적인 디자인을 연출합니다.', engName: 'Gradient Coating' },
    ],
  },
  {
    id: 'part-body',
    code: '03',
    name: '본체',
    engName: 'Body',
    methods: [
      { id: 'method-01', code: '01', name: '유광코팅 (Gloss Coating)', description: '광택 코팅 마감 처리로 표면에 광택을 부여합니다. 투명하고 반짝이는 마감이 특징입니다.', engName: 'Gloss Coating' },
      { id: 'method-02', code: '02', name: '무광코팅 (Matte Coating)', description: '무광 코팅 마감 처리로 표면을 부드럽고 차분하게 마감합니다. 지문이 잘 묻지 않는 실용적인 마감입니다.', engName: 'Matte Coating' },
      { id: 'method-05', code: '05', name: '반투명코팅 (Translucent Coating)', description: '반투명 코팅으로 용기 내부가 은은하게 비치는 효과를 연출합니다. 내용물의 컬러를 활용한 디자인에 적합합니다.', engName: 'Translucent Coating' },
      { id: 'method-06', code: '06', name: '샌딩연마 (Sanding Coating)', description: '표면을 섬세하게 연마하여 프로스팅 효과를 냅니다. 부드러운 무광택 질감과 세련된 외관을 제공합니다.', engName: 'Sanding Coating' },
      { id: 'method-07', code: '07', name: '칼라코팅 (Color Coating)', description: '원하는 색상으로 용기 전체를 컬러 코팅합니다. 균일하고 선명한 발색이 특징입니다.', engName: 'Color Coating' },
      { id: 'method-10', code: '10', name: '그라데이션코팅 (Gradient Coating)', description: '두 가지 이상의 색상을 자연스럽게 그라데이션으로 코팅하여 감각적인 디자인을 연출합니다.', engName: 'Gradient Coating' },
    ],
  },
  {
    id: 'part-pump',
    code: '07',
    name: '펌프',
    engName: 'Pump',
    methods: [
      { id: 'method-01', code: '01', name: '유광코팅 (Gloss Coating)', description: '광택 코팅 마감 처리로 표면에 광택을 부여합니다.', engName: 'Gloss Coating' },
      { id: 'method-02', code: '02', name: '무광코팅 (Matte Coating)', description: '무광 코팅 마감 처리로 표면을 부드럽고 차분하게 마감합니다.', engName: 'Matte Coating' },
      { id: 'method-08', code: '08', name: '도금증착 (Plating Coating)', description: '금속 이온을 표면에 증착하여 메탈릭한 외관을 구현합니다.', engName: 'Plating Coating' },
    ],
  },
  {
    id: 'part-base',
    code: '02',
    name: '중간테두리',
    engName: 'Middle Ring',
    methods: [
      { id: 'method-01', code: '01', name: '유광코팅 (Gloss Coating)', description: '광택 코팅 마감 처리로 표면에 광택을 부여합니다.', engName: 'Gloss Coating' },
      { id: 'method-02', code: '02', name: '무광코팅 (Matte Coating)', description: '무광 코팅 마감 처리로 표면을 부드럽고 차분하게 마감합니다.', engName: 'Matte Coating' },
      { id: 'method-08', code: '08', name: '도금증착 (Plating Coating)', description: '금속 이온을 표면에 증착하여 메탈릭한 외관을 구현합니다.', engName: 'Plating Coating' },
    ],
  },
];

// ─────────────── 인기 컬러 85종 ───────────────
export const popularColors: ColorOption[] = [
  // ── Yellow (8) ──
  { name: 'Bright Yellow', hex: '#F6EB61', category: 'Yellow', pantoneCode: 'Pantone 100 C', tier: 'popular' },
  { name: 'Lemon Yellow', hex: '#F9E547', category: 'Yellow', pantoneCode: 'Pantone 102 C', tier: 'popular' },
  { name: 'Pale Yellow', hex: '#F7E8A1', category: 'Yellow', pantoneCode: 'Pantone 106 C', tier: 'popular' },
  { name: 'Cream Yellow', hex: '#FCE364', category: 'Yellow', pantoneCode: 'Pantone 108 C', tier: 'popular' },
  { name: 'Golden Yellow', hex: '#FFCD00', category: 'Yellow', pantoneCode: 'Pantone 116 C', tier: 'popular' },
  { name: 'Marigold', hex: '#FDDA24', category: 'Yellow', pantoneCode: 'Pantone 123 C', tier: 'popular' },
  { name: 'Amber Yellow', hex: '#F2A900', category: 'Yellow', pantoneCode: 'Pantone 130 C', tier: 'popular' },
  { name: 'Honey', hex: '#EAAA00', category: 'Yellow', pantoneCode: 'Pantone 137 C', tier: 'popular' },

  // ── Orange (9) ──
  { name: 'Warm Orange', hex: '#F2994A', category: 'Orange', pantoneCode: 'Pantone 144 C', tier: 'popular' },
  { name: 'Mandarin', hex: '#F68D2E', category: 'Orange', pantoneCode: 'Pantone 150 C', tier: 'popular' },
  { name: 'Vivid Orange', hex: '#F96E1E', category: 'Orange', pantoneCode: 'Pantone 151 C', tier: 'popular' },
  { name: 'Burnt Orange', hex: '#E97132', category: 'Orange', pantoneCode: 'Pantone 158 C', tier: 'popular' },
  { name: 'Deep Orange', hex: '#E85826', category: 'Orange', pantoneCode: 'Pantone 165 C', tier: 'popular' },
  { name: 'Tangerine', hex: '#FF6A39', category: 'Orange', pantoneCode: 'Pantone 164 C', tier: 'popular' },
  { name: 'Pumpkin', hex: '#F2552C', category: 'Orange', pantoneCode: 'Pantone 172 C', tier: 'popular' },
  { name: 'Peach', hex: '#F2A68D', category: 'Orange', pantoneCode: 'Pantone 155 C', tier: 'popular' },
  { name: 'Coral', hex: '#F28B82', category: 'Orange', pantoneCode: 'Pantone 163 C', tier: 'popular' },

  // ── Red (12) ──
  { name: 'Warm Red', hex: '#FF3C38', category: 'Red', pantoneCode: 'Pantone 1788 C', tier: 'popular' },
  { name: 'Bright Red', hex: '#E03C31', category: 'Red', pantoneCode: 'Pantone 179 C', tier: 'popular' },
  { name: 'Scarlet', hex: '#BE3A34', category: 'Red', pantoneCode: 'Pantone 180 C', tier: 'popular' },
  { name: 'Process Red', hex: '#E81D3A', category: 'Red', pantoneCode: 'Pantone 185 C', tier: 'popular' },
  { name: 'True Red', hex: '#CE1126', category: 'Red', pantoneCode: 'Pantone 186 C', tier: 'popular' },
  { name: 'Crimson', hex: '#A6192E', category: 'Red', pantoneCode: 'Pantone 187 C', tier: 'popular' },
  { name: 'Ruby Red', hex: '#9B1B30', category: 'Red', pantoneCode: 'Pantone 194 C', tier: 'popular' },
  { name: 'Dark Red', hex: '#D93A3A', category: 'Red', pantoneCode: 'Pantone 199 C', tier: 'popular' },
  { name: 'Burgundy', hex: '#9E1B32', category: 'Red', pantoneCode: 'Pantone 201 C', tier: 'popular' },
  { name: 'Wine', hex: '#862633', category: 'Red', pantoneCode: 'Pantone 202 C', tier: 'popular' },
  { name: 'Cherry', hex: '#C8102E', category: 'Red', pantoneCode: 'Pantone 192 C', tier: 'popular' },
  { name: 'Rose Red', hex: '#D50032', category: 'Red', pantoneCode: 'Pantone 193 C', tier: 'popular' },

  // ── Pink (12) ──
  { name: 'Baby Pink', hex: '#F9A3C2', category: 'Pink', pantoneCode: 'Pantone 203 C', tier: 'popular' },
  { name: 'Blossom Pink', hex: '#F4B3C2', category: 'Pink', pantoneCode: 'Pantone 204 C', tier: 'popular' },
  { name: 'Soft Pink', hex: '#F2C1CF', category: 'Pink', pantoneCode: 'Pantone 210 C', tier: 'popular' },
  { name: 'Candy Pink', hex: '#F5B0CB', category: 'Pink', pantoneCode: 'Pantone 211 C', tier: 'popular' },
  { name: 'Bubblegum', hex: '#F2A3BD', category: 'Pink', pantoneCode: 'Pantone 212 C', tier: 'popular' },
  { name: 'Hot Pink', hex: '#E31C79', category: 'Pink', pantoneCode: 'Pantone 219 C', tier: 'popular' },
  { name: 'Fuchsia', hex: '#CE0058', category: 'Pink', pantoneCode: 'Pantone 226 C', tier: 'popular' },
  { name: 'Magenta Pink', hex: '#AA0061', category: 'Pink', pantoneCode: 'Pantone 227 C', tier: 'popular' },
  { name: 'Rose', hex: '#DB3EB1', category: 'Pink', pantoneCode: 'Pantone 238 C', tier: 'popular' },
  { name: 'Deep Pink', hex: '#C41E82', category: 'Pink', pantoneCode: 'Pantone 239 C', tier: 'popular' },
  { name: 'Orchid', hex: '#DB5BB2', category: 'Pink', pantoneCode: 'Pantone 240 C', tier: 'popular' },
  { name: 'Lavender Pink', hex: '#D4A0D4', category: 'Pink', pantoneCode: 'Pantone 236 C', tier: 'popular' },

  // ── Purple / Violet (10) ──
  { name: 'Lilac', hex: '#B38FC4', category: 'Purple', pantoneCode: 'Pantone 246 C', tier: 'popular' },
  { name: 'Deep Purple', hex: '#8E1C5A', category: 'Purple', pantoneCode: 'Pantone 248 C', tier: 'popular' },
  { name: 'Violet', hex: '#981D97', category: 'Purple', pantoneCode: 'Pantone 254 C', tier: 'popular' },
  { name: 'Royal Purple', hex: '#6C3B9E', category: 'Purple', pantoneCode: 'Pantone 259 C', tier: 'popular' },
  { name: 'Plum', hex: '#5B2C8E', category: 'Purple', pantoneCode: 'Pantone 262 C', tier: 'popular' },
  { name: 'Amethyst', hex: '#8A7EC8', category: 'Purple', pantoneCode: 'Pantone 266 C', tier: 'popular' },
  { name: 'Deep Violet', hex: '#442C8E', category: 'Purple', pantoneCode: 'Pantone 268 C', tier: 'popular' },
  { name: 'Ultra Violet', hex: '#5F4B8B', category: 'Purple', pantoneCode: 'Pantone 269 C', tier: 'popular' },
  { name: 'Mauve', hex: '#BB8DBB', category: 'Purple', pantoneCode: 'Pantone 257 C', tier: 'popular' },
  { name: 'Grape', hex: '#4B2A7B', category: 'Purple', pantoneCode: 'Pantone 275 C', tier: 'popular' },

  // ── Blue (13) ──
  { name: 'Periwinkle', hex: '#8BAAD9', category: 'Blue', pantoneCode: 'Pantone 272 C', tier: 'popular' },
  { name: 'Light Blue', hex: '#7BA7D0', category: 'Blue', pantoneCode: 'Pantone 278 C', tier: 'popular' },
  { name: 'Navy Blue', hex: '#003DA5', category: 'Blue', pantoneCode: 'Pantone 280 C', tier: 'popular' },
  { name: 'Midnight Blue', hex: '#00205B', category: 'Blue', pantoneCode: 'Pantone 281 C', tier: 'popular' },
  { name: 'Sky Blue', hex: '#0077C8', category: 'Blue', pantoneCode: 'Pantone 285 C', tier: 'popular' },
  { name: 'Classic Blue', hex: '#0033A0', category: 'Blue', pantoneCode: 'Pantone 286 C', tier: 'popular' },
  { name: 'Royal Blue', hex: '#003594', category: 'Blue', pantoneCode: 'Pantone 287 C', tier: 'popular' },
  { name: 'Reflex Blue', hex: '#0047BB', category: 'Blue', pantoneCode: 'Pantone 293 C', tier: 'popular' },
  { name: 'Deep Blue', hex: '#002F6C', category: 'Blue', pantoneCode: 'Pantone 294 C', tier: 'popular' },
  { name: 'Process Blue', hex: '#009CDE', category: 'Blue', pantoneCode: 'Pantone 299 C', tier: 'popular' },
  { name: 'Ocean Blue', hex: '#0061A7', category: 'Blue', pantoneCode: 'Pantone 300 C', tier: 'popular' },
  { name: 'Cyan', hex: '#00B5E2', category: 'Blue', pantoneCode: 'Pantone 306 C', tier: 'popular' },
  { name: 'Aqua Blue', hex: '#00A3E0', category: 'Blue', pantoneCode: 'Pantone 312 C', tier: 'popular' },

  // ── Green / Teal (13) ──
  { name: 'Turquoise', hex: '#00B2A9', category: 'Green', pantoneCode: 'Pantone 320 C', tier: 'popular' },
  { name: 'Teal', hex: '#007C85', category: 'Green', pantoneCode: 'Pantone 321 C', tier: 'popular' },
  { name: 'Deep Teal', hex: '#006B6B', category: 'Green', pantoneCode: 'Pantone 322 C', tier: 'popular' },
  { name: 'Mint', hex: '#00AB84', category: 'Green', pantoneCode: 'Pantone 339 C', tier: 'popular' },
  { name: 'Emerald', hex: '#009B77', category: 'Green', pantoneCode: 'Pantone 340 C', tier: 'popular' },
  { name: 'Kelly Green', hex: '#00843D', category: 'Green', pantoneCode: 'Pantone 347 C', tier: 'popular' },
  { name: 'Forest Green', hex: '#006B3F', category: 'Green', pantoneCode: 'Pantone 349 C', tier: 'popular' },
  { name: 'Bright Green', hex: '#00A85C', category: 'Green', pantoneCode: 'Pantone 354 C', tier: 'popular' },
  { name: 'Lime Green', hex: '#78BE20', category: 'Green', pantoneCode: 'Pantone 368 C', tier: 'popular' },
  { name: 'Leaf Green', hex: '#42B500', category: 'Green', pantoneCode: 'Pantone 375 C', tier: 'popular' },
  { name: 'Olive Green', hex: '#8A8D4A', category: 'Green', pantoneCode: 'Pantone 384 C', tier: 'popular' },
  { name: 'Sage', hex: '#A6AA71', category: 'Green', pantoneCode: 'Pantone 5777 C', tier: 'popular' },
  { name: 'Matcha', hex: '#B4C87C', category: 'Green', pantoneCode: 'Pantone 367 C', tier: 'popular' },

  // ── Brown / Beige (8) ──
  { name: 'Warm Beige', hex: '#D1C0A5', category: 'Brown', pantoneCode: 'Pantone 467 C', tier: 'popular' },
  { name: 'Tan', hex: '#C4A67E', category: 'Brown', pantoneCode: 'Pantone 465 C', tier: 'popular' },
  { name: 'Caramel', hex: '#BA8C63', category: 'Brown', pantoneCode: 'Pantone 464 C', tier: 'popular' },
  { name: 'Chocolate', hex: '#7B5541', category: 'Brown', pantoneCode: 'Pantone 469 C', tier: 'popular' },
  { name: 'Dark Brown', hex: '#5C3A28', category: 'Brown', pantoneCode: 'Pantone 478 C', tier: 'popular' },
  { name: 'Espresso', hex: '#4D3626', category: 'Brown', pantoneCode: 'Pantone 476 C', tier: 'popular' },
  { name: 'Sand', hex: '#DEC9AB', category: 'Brown', pantoneCode: 'Pantone 468 C', tier: 'popular' },
  { name: 'Terracotta', hex: '#C66E4E', category: 'Brown', pantoneCode: 'Pantone 471 C', tier: 'popular' },
];

// ─────────────── Premium 컬러 21종 ───────────────
export const premiumColors: ColorOption[] = [
  // ── Metallic (8) ──
  { name: 'Metallic Gold', hex: '#84734E', category: 'Metallic', pantoneCode: 'Pantone 871 C', tier: 'premium', subcategory: 'metallic' },
  { name: 'Pale Gold', hex: '#9A8A5C', category: 'Metallic', pantoneCode: 'Pantone 872 C', tier: 'premium', subcategory: 'metallic' },
  { name: 'Bright Gold', hex: '#B59A6B', category: 'Metallic', pantoneCode: 'Pantone 873 C', tier: 'premium', subcategory: 'metallic' },
  { name: 'Champagne Gold', hex: '#C6B88A', category: 'Metallic', pantoneCode: 'Pantone 874 C', tier: 'premium', subcategory: 'metallic' },
  { name: 'Rose Gold', hex: '#D4A08A', category: 'Metallic', pantoneCode: 'Pantone 875 C', tier: 'premium', subcategory: 'metallic' },
  { name: 'Cream Gold', hex: '#E0D4B4', category: 'Metallic', pantoneCode: 'Pantone 876 C', tier: 'premium', subcategory: 'metallic' },
  { name: 'Metallic Silver', hex: '#C0C4C4', category: 'Metallic', pantoneCode: 'Pantone 877 C', tier: 'premium', subcategory: 'metallic' },
  { name: 'Bronze', hex: '#8C6E4A', category: 'Metallic', pantoneCode: 'Pantone 8640 C', tier: 'premium', subcategory: 'metallic' },

  // ── Pearl (7) ──
  { name: 'Pearl White', hex: '#F8F6F0', category: 'Pearl', pantoneCode: 'Pantone 9060 C', tier: 'premium', subcategory: 'pearl' },
  { name: 'Pearl Pink', hex: '#F5E0DE', category: 'Pearl', pantoneCode: 'Pantone 9061 C', tier: 'premium', subcategory: 'pearl' },
  { name: 'Pearl Rose', hex: '#EDD0CD', category: 'Pearl', pantoneCode: 'Pantone 9062 C', tier: 'premium', subcategory: 'pearl' },
  { name: 'Pearl Lavender', hex: '#E4DAE8', category: 'Pearl', pantoneCode: 'Pantone 9063 C', tier: 'premium', subcategory: 'pearl' },
  { name: 'Pearl Blue', hex: '#D8E4EB', category: 'Pearl', pantoneCode: 'Pantone 9064 C', tier: 'premium', subcategory: 'pearl' },
  { name: 'Pearl Mint', hex: '#DBEBE0', category: 'Pearl', pantoneCode: 'Pantone 9065 C', tier: 'premium', subcategory: 'pearl' },
  { name: 'Pearl Champagne', hex: '#F2ECDA', category: 'Pearl', pantoneCode: 'Pantone 9140 C', tier: 'premium', subcategory: 'pearl' },

  // ── Soft-touch (6) ──
  { name: 'Soft-touch Ivory', hex: '#F5F2E8', category: 'Soft-touch', pantoneCode: 'Pantone 7499 C', tier: 'premium', subcategory: 'soft-touch' },
  { name: 'Soft-touch Blush', hex: '#EED5D0', category: 'Soft-touch', pantoneCode: 'Pantone 5035 C', tier: 'premium', subcategory: 'soft-touch' },
  { name: 'Soft-touch Sage', hex: '#CED9C3', category: 'Soft-touch', pantoneCode: 'Pantone 5783 C', tier: 'premium', subcategory: 'soft-touch' },
  { name: 'Soft-touch Sky', hex: '#D2DCE8', category: 'Soft-touch', pantoneCode: 'Pantone 644 C', tier: 'premium', subcategory: 'soft-touch' },
  { name: 'Soft-touch Taupe', hex: '#C5BDB3', category: 'Soft-touch', pantoneCode: 'Pantone 7530 C', tier: 'premium', subcategory: 'soft-touch' },
  { name: 'Soft-touch Charcoal', hex: '#707070', category: 'Soft-touch', pantoneCode: 'Pantone 7540 C', tier: 'premium', subcategory: 'soft-touch' },
];

// 전체 색상 (기존 코드 호환용)
export const colorPalette: ColorOption[] = [...popularColors, ...premiumColors];